import { NodeType } from "../NodeType";

export {
  DelayMode,
  TDelayMode,
  TDelayNode,
  TDelayNodeConfig,
  delayModeConfig,
  defaultDelayNode,
  defaultFixedDelayNode,
  defaultDynamicSecondsDelayNode,
  defaultUntilTimestampDelayNode,
  DelaySkipIfPastOutputPort,
  delaySkipIfPastOutputPortsConfig,
  TDelayNodeFixedConfig,
  TDelayNodeDynamicSecondsConfig,
  TDelayNodeUntilTimestampConfig,
};

type TDelayNode = {
  nodeId: string;
  name: string;
  type: typeof NodeType.DELAY;
  config: TDelayNodeConfig;
};

const DelayMode = {
  FIXED: "fixed",
  UNTIL_TIMESTAMP: "until_timestamp",
  DYNAMIC_SECONDS: "dynamic_seconds",
} as const;

type TDelayMode = (typeof DelayMode)[keyof typeof DelayMode];

const delayModeConfig = {
  [DelayMode.FIXED]: { label: "Fixed", value: DelayMode.FIXED },
  [DelayMode.UNTIL_TIMESTAMP]: {
    label: "Until Timestamp",
    value: DelayMode.UNTIL_TIMESTAMP,
  },
  [DelayMode.DYNAMIC_SECONDS]: {
    label: "Dynamic Seconds",
    value: DelayMode.DYNAMIC_SECONDS,
  },
};

const DelaySkipIfPastOutputPort = {
  DEFAULT: "default",
  SKIPPED: "skipped",
};

const delaySkipIfPastOutputPortsConfig = {
  [DelaySkipIfPastOutputPort.DEFAULT]: {
    label: "Default",
    outputPort: DelaySkipIfPastOutputPort.DEFAULT,
    color: "zinc",
  },
  [DelaySkipIfPastOutputPort.SKIPPED]: {
    label: "Skipped",
    color: "pink",
    outputPort: DelaySkipIfPastOutputPort.SKIPPED,
  },
};

const defaultDelayNode = {
  name: "Delay",
  description: "",
  type: NodeType.DELAY,
  delayMode: DelayMode.FIXED,
  delaySeconds: 0,
  delayExpression: "",
  offsetSeconds: 0,
  minimumDelaySeconds: 0,
  skipIfPast: false,
};

const defaultFixedDelayNode = {
  name: "Delay",
  description: "",
  type: NodeType.DELAY,
  delayMode: DelayMode.FIXED,
  delaySeconds: 0,
};

const defaultUntilTimestampDelayNode = {
  name: "Delay Until",
  description: "",
  type: NodeType.DELAY,
  delayMode: DelayMode.UNTIL_TIMESTAMP,
  delayExpression: "",
  offsetSeconds: 0,
  minimumDelaySeconds: 0,
  skipIfPast: false,
};

const defaultDynamicSecondsDelayNode = {
  name: "Delay Dynamic",
  description: "",
  type: NodeType.DELAY,
  delayMode: DelayMode.DYNAMIC_SECONDS,
  delayExpression: "",
  offsetSeconds: 0,
  minimumDelaySeconds: 0,
};

type TDelayNodeConfig =
  | TDelayNodeFixedConfig
  | TDelayNodeDynamicSecondsConfig
  | TDelayNodeUntilTimestampConfig;

type TDelayNodeFixedConfig = {
  name: string;
  description?: string;
  delayMode: typeof DelayMode.FIXED;
  delaySeconds: 0;
};

type TDelayNodeUntilTimestampConfig = {
  name: string;
  description?: string;
  delayMode: typeof DelayMode.UNTIL_TIMESTAMP;
  delayExpression: string;
  offsetSeconds: string;
  minimumDelaySeconds: string;
  skipIfPast: boolean;
};

type TDelayNodeDynamicSecondsConfig = {
  name: string;
  description?: string;
  delayMode: typeof DelayMode.DYNAMIC_SECONDS;
  delayExpression: string;
  offsetSeconds: string;
  minimumDelaySeconds: string;
};
